import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ChatComponent } from './chat/chat.component';
import { AuthGuard } from '../core/guards/auth.guard';

const routes: Routes = [
    {
        path: '', component: DashboardComponent, canActivate: [AuthGuard],
    },
    { path: 'calendar', component: CalendarComponent },
    { path: 'chat', component: ChatComponent },
    { path: 'email', loadChildren: () => import('./email/email.module').then(m => m.EmailModule) },
    { path: 'pages', loadChildren: () => import('./utility/utility.module').then(m => m.UtilityModule) },
    { path: 'charts', loadChildren: () => import('./chart/chart.module').then(m => m.ChartModule) },
    { path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule) },
    { path: 'users', loadChildren: () => import('./user/user.module').then(m => m.UserModule), canActivate: [AuthGuard], },
    { path: 'category', loadChildren: () => import('./category/category.module').then(m => m.CategoryModule) },
    { path: 'brand', loadChildren: () => import('./brands/brands.module').then(m => m.BrandsModule) },
    { path: 'tags', loadChildren: () => import('./tags/tags.module').then(m => m.TagsModule) },
    { path: 'gift', loadChildren: () => import('./gifts/gifts.module').then(m => m.GiftsModule) },
    { path: 'product', loadChildren: () => import('./product/product.module').then(m => m.ProductModule) },
    { path: 'stock', loadChildren: () => import('./stock/stock.module').then(m => m.StockModule) },
    { path: 'order', loadChildren: () => import('./order/order.module').then(m => m.OrderModule) },
    { path: 'reviews', loadChildren: () => import('./reviews/reviews.module').then(m => m.ReviewsModule) },
    { path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule) },
    { path: 'returnexchnages', loadChildren: () => import('./returnexchange/returnexchange.module').then(m => m.ReturnexchangeModule) },
    { path: 'homeBanner', loadChildren: () => import('./web-home/web-home.module').then(m => m.WebHomeModule) },
    { path: 'AboutUs', loadChildren: () => import('./about/about.module').then(m => m.AboutModule) },
    { path: 'catalogCategory', loadChildren: () => import('./catalog-category/catalog-category.module').then(m => m.CatalogCategoryModule) },
    { path: 'suppliers', loadChildren: () => import('./supplier/supplier.module').then(m => m.SupplierModule) },
    { path: 'trash', loadChildren: () => import('./trash/trash.module').then(m => m.TrashModule) },
    { path: 'purchase', loadChildren: () => import('./purchase/purchase.module').then(m => m.PurchaseModule) },
    { path: 'supplierLedger', loadChildren: () => import('./supplier-ledger/supplier-ledger.module').then(m => m.SupplierLedgerModule) },
    { path: 'projectClients', loadChildren: () => import('./project-clients/project-clients.module').then(m => m.ProjectClientsModule) },


];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
